import { render, staticRenderFns } from "./TransactionIcon.vue?vue&type=template&id=06c68b56&"
import script from "./TransactionIcon.vue?vue&type=script&lang=js&"
export * from "./TransactionIcon.vue?vue&type=script&lang=js&"
import style0 from "./TransactionIcon.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports